import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const OrderListState = Immutable.fromJS({
	orderList: [],
	activePage: 1,
	itemPerPage: 10,
	totalPage: 1,
	searchWord: ''
});

const orderListReducer = handleActions({
	FIND_ORDER_LIST: (state, { payload }) => {
		return state.merge({
			orderList: payload.data.dataTableData,
			activePage: payload.data.activePage,
			totalPage: payload.data.totalPage,
			itemPerPage: payload.data.itemPerPage,
			searchWord: payload.data.searchWord,
		})
	},
	CHANGE_ORDER_ACTIVE_PAGE:(state, { payload }) => {
		return state.merge({
			activePage: payload.activePage,
			itemPerPage: payload.itemPerPage
		})
	}
}, OrderListState);

export default orderListReducer;


// WEBPACK FOOTER //
// ./src/reducers/orderListReducer.js